# Used in onboarding
# Allow to hide a given element, when the current input/select has a speficic value.
# Example: Hides the additionnal identity card upload, when a person selected the "CH" nationality

HIDE_VIEW_ON = '[data-behaviour="hide-view-on"]'

init = ->
  $(HIDE_VIEW_ON).each updateView

updateView = ->
  $this = $ this
  tgl = $this.val() != '' && $this.val() != $this.data('value')
  $($this.data('view')).toggle(tgl).find().find('input,select,textarea').prop('disabled', !tgl)

$(document).on 'change', HIDE_VIEW_ON, updateView

$(document).ready(init)
